import { useEffect, useRef, useState } from "react";
import { Box, CircularProgress, IconButton, TextField } from "@mui/material";
import { downloadTemporaryFileRequest } from "../../../../utils/APICalls";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { useSortable } from "@dnd-kit/react/sortable";

export default function PhotosList({
  photoData,
  id,
  index,
  onDescriptionUpdate,
  onDelete,
  disabled,
}: any) {
  const { ref, handleRef } = useSortable({ id, index, disabled: disabled });
  const [photoUrl, setPhotoUrl] = useState("");
  const [description, setDescription] = useState<string | null>(null);

  const prevKeyRef = useRef(null);
  const prevDescriptionRef = useRef(null);

  useEffect(() => {
    if (photoData) {
      if (photoData.key !== prevKeyRef.current) {
        prevKeyRef.current = photoData.key;
        getPhotoUrl(photoData.key);
      }
      if (photoData.description !== prevDescriptionRef.current) {
        prevDescriptionRef.current = photoData.description;
        setDescription(photoData.description);
      }
    }
  }, [photoData]);

  useEffect(() => {
    if (photoData) {
      const prevValue = photoData?.description;
      const delayInputTimeoutId = setTimeout(() => {
        if (description !== null && prevValue !== description) {
          onDescriptionUpdate(description, photoData?.key);
        }
      }, 300);
      return () => clearTimeout(delayInputTimeoutId);
    }
  }, [description, photoData]); // eslint-disable-line

  const getPhotoUrl = async (key: string) => {
    const response = await downloadTemporaryFileRequest(key);
    if (response && response.data) {
      setPhotoUrl(response.data);
    }
  };

  return (
    <Box ref={ref}>
      <Box
        sx={{
          border: "1px solid #C4C4C4",
          p: 2,
          display: "flex",
          mt: 1,
        }}
      >
        <Box
          sx={{
            width: 300,
            height: 200,
            position: "relative",
          }}
        >
          {!photoUrl ? (
            <CircularProgress
              size={24}
              sx={{ position: "absolute", top: "45%", left: "45%" }}
            />
          ) : (
            <Box
              component="img"
              src={photoUrl}
              alt="Photo"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          )}
        </Box>
        <TextField
          sx={{ width: "100%", mx: 2 }}
          id="description-multiline"
          label="Description"
          multiline
          rows={4}
          value={description || ""}
          disabled={disabled}
          onChange={(e) => setDescription(e.target.value)}
        />
        <IconButton
          sx={{ height: 40 }}
          aria-label="delete"
          onClick={() => onDelete(photoData?.key)}
          disabled={disabled}
        >
          <DeleteOutlinedIcon color={disabled ? "disabled" : "error"} />
        </IconButton>
        <IconButton
          sx={{ height: 40 }}
          ref={handleRef}
          disabled={disabled}
        >
          <DragIndicatorIcon color={disabled ? "disabled" : "primary"} />
        </IconButton>
      </Box>
    </Box>
  );
}
